import { render } from "./ReportModal.vue?vue&type=template&id=a0d60732&scoped=true"
import script from "./ReportModal.vue?vue&type=script&lang=js"
export * from "./ReportModal.vue?vue&type=script&lang=js"

import "./ReportModal.vue?vue&type=style&index=0&id=a0d60732&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d60732"]])

export default __exports__